<template>
	<div id="contactUs" class="contactUs">
		<h2>联系方式：</h2>
		<div>
			<img v-lazy="'../../static/img/phone.png'" style="width:1.9vw;margin-left:1.5%" alt="">
			<div>
				<p>联系电话：</p>
				<p>400-966-2156</p>
			</div>
		</div>
		<div style="border-bottom: #E1E1E1 0.2vw dashed;">
			<img v-lazy="'../../static/img/email.png'" alt="">
			<div style="margin-bottom:3vw;">
				<p>邮箱：</p>
				<p>alink@shyingsu.cn</p>
			</div>
		</div>
		<p style="margin-left:10%;font-size:2vw;color: #999999;">查看路线</p>
		<div>
			<img v-lazy="'../../static/img/location.png'" style="width:1.7vw;margin-left:1.5%" alt="">
			<div>
				<p>公司地址：</p>
				<p>上海市宝山区城银路555弄6号2幢2楼</p>
			</div>
		</div>
		<img v-lazy="'../../static/img/map.png'" style="width:100%;margin:0px" alt="" @click="clickMethod">
	</div>
</template>

<script>
export default {
data () {
return {}
},
created () {},
mounted () {},
methods: {
	clickMethod () {
		window.open('https://www.amap.com/search?query=上海鹰速物流有限公司', '_blank')
	}
}
}
</script>
<style lang="less" scoped>
#driver{
	margin-top: 50px;
}
.contactUs {
	text-align:left;
	h2 {
		color:#343434;
		padding-top:50px;
		font-size:2vw;
		margin-left:10%;
	}
	div {
		margin:40px 10%;
		display: flex;
		img {
			margin:0px;
			width:3vw;
			height:2vw;
			margin-right:3vw;
		}
		div {
			margin: 0px;
			display: flex;
			flex-direction: column;
			p {
				font-size: 1vw;
				color: #999;
				margin-bottom: 0.8vw;
			}
		}
	}
	img {
		width:80%;
		margin-bottom:50px;margin-top:30px;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/FooterNew.vue